const vaiAccordion = (function(){
	/** Private **/
	const allArticles = Array.from(document.querySelectorAll('.vai-accordion article'));

	function hideAllArticles() {
		allArticles.forEach(article => {
			article.classList.remove('active');
			article.style.maxHeight = '50px';
		});
	}

	function toggleAccordion({currentTarget : articleToShow, target}){
		// If Article isnt active -> show aimed article
		if(!articleToShow.classList.contains('active')) {
			// 1. remove all active classes and hide all article sub-contents
			hideAllArticles();


			// 2. Add active-class to current and set maxheight
			articleToShow.classList.add('active');
			articleToShow.style.maxHeight = '400px';
		}
		// If article is active + you clicked on the headline -> close all articles
		else if(target.tagName === "H2"){
			hideAllArticles();
		}
	}

	/** Public **/
	function setup(){
		allArticles.forEach(article => article.addEventListener('click',toggleAccordion));
	}

	return setup;
})();